import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { ToastService } from '@core/services/toast.service';
import { AuthenticationStorageService } from '@core/storage/jwt-storage-service';

@Injectable()
export class ComingSoonGuard implements CanActivate, CanActivateChild {
    constructor(
        private _authStorageService: AuthenticationStorageService,
        private _toastService: ToastService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this._toastService.warn('Coming Soon!');
        return false;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const requiredPermission = route.data['permissions'] as Array<number>;
        const canActivate = this._authStorageService.hasAllPermission(requiredPermission);
        if (canActivate === false) {
            this._toastService.error('You do not have permission to view this.');
        }
        return canActivate;
    }
}
